import template from './requestFormSicknessPanel.html';
import controller from './requestFormSicknessPanel.controller';
import './requestFormSicknessPanel.scss';

let requestFormSicknessPanelComponent = {
  restrict: 'E',
  bindings: {
    originalPeriod: '<',
    openSicknessPanel: '&',
    sicknessPanelIsOpen: '&',
    isEditSickness: '&',
    sickDescription: '<',
    reports: '<',
    isMobileApp: '<'
  },
  template,
  controller
};

export default requestFormSicknessPanelComponent;



// WEBPACK FOOTER //
// ./client/app/vacations-absences.module/components/modals/modalRequest/requestForm/requestFormSicknessPanel/requestFormSicknessPanel.component.js